"use client";

import Cookies from "js-cookie";
import {
  USER_LOCATION_COOKIE,
  USER_REGION_COOKIE,
  USER_MOBILE_COOKIE,
  LOCATION_OVERRIDE_COOKIE,
} from "./constants";

export interface UserContext {
  country: string | null;
  region: string | null;
  isMobile: boolean | null;
}

const getUserContextFromClient = (): UserContext => {
  // Get country (with override support)
  const country =
    Cookies.get(LOCATION_OVERRIDE_COOKIE) ||
    Cookies.get(USER_LOCATION_COOKIE) ||
    null;

  // Get region
  const region = Cookies.get(USER_REGION_COOKIE) || null;

  // Get mobile status
  const mobileValue = Cookies.get(USER_MOBILE_COOKIE);
  const isMobile = mobileValue ? mobileValue === "true" : null;

  return {
    country,
    region,
    isMobile,
  };
};

export default getUserContextFromClient;
